import script from "./TheoDoiHopDongPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheoDoiHopDongPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./TheoDoiHopDongPrintTemplate.vue?vue&type=style&index=0&id=92431012&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92431012"]])

export default __exports__